export { resizeImageClient } from './resizeImageClient';

export function getImageFullUrl(imageUrl: string): string {
  return import.meta.env.MODE === 'development'
    ? `https://pub-78f29ca659c643619854d230f6d4df70.r2.dev/${imageUrl}`
    : `https://cdn.face.golf/${imageUrl}`;
}
